import { wxShare } from '../../common/utils/wxShare';
import { ajax } from "../../common/utils/tool";

export const api = {
    getList: HOST + '/app-front/luckydraw/prizes', //获取奖品信息
    getWinRecord: HOST + '/app-front/luckydraw/winRecord', //邀请记录
    getPrize: HOST + '/app-front/luckydraw/drawAndAccept', //抽奖计算
    ldyRegister: HOST + '/app-front/bnhuser/ldyRegisterN', //落地页注册
    dynamicCode: HOST + '/app-front/bnhuser/ldyDynamicCode', //落地页二维码
    getWxInfoUrl : HOST + '/app-front/active/getShareImage',
    wechatShareUrl : HOST + '/app-front/bnhuser/getSignature',
    maidianUrl: HOST + '/app-front/general/pageStaticinfo', //落地页营销埋点
};

export const execWxShare = (activeId) => {
	ajax(api.getWxInfoUrl, {activeId, environmentInfo: {gpsProvince: '北京市', gpsCity: '北京市'}}, data => {
        if(data.statusInfo.code === 'COMCC00000'){
			let { url: imgUrl, name: title, detail: desc } = data;
			ajax(api.wechatShareUrl, {url: window.location.href}, data => {
				if(data.RespCode == '0000' || data.RespCode == '"0000"'){
					let { appId, nonceStr, timestamp, signature, url: link } = data.share;
                    wxShare({ imgUrl, title, desc, appId, nonceStr, timestamp, signature, link });
				}else{
					console.log("请求失败respCode非0");
				}
			}, false);
		}
	}, false);
};

export const getToken = (fn) => {
	ajax(api.getToken, '', data => {
		fn(data.token);
	}, false, false, 'GET');
};

export const getImgUrl = (uuid, fn) => {
    fn(api.imgCodeUrl + '?serialNo=' + uuid);
};

export const sendSms = (deviceKey, phoneNumber, token, imageId, imageCode, fn, errFn) => {
    const codeSendData = {
        phoneNumber, 
        codeType: '01', 
        imageId, 
        imageCode, 
        environmentInfo: {
            gpsProvince: '北京市', 
            gpsCity: '北京市'
        },
        type: 'rec',
        terminalInfo: {deviceKey}
    };
    ajax(api.codeSendImgUrl, codeSendData, [data => {
        fn && fn(data);
    }, () => {
        errFn && errFn();
    }], false, false, 'POST', false, token);
};